<template>
  <div class="page_bg">
    <div v-if="reload" class="cart_company">
      <div v-if="proList.length>0" class="cart_top_btn flex-r-sb-c">
        <div class="cart_title flex-r-s-c" @click="backPath"><van-icon name="arrow-left" style="margin-right:0.15rem" />
          <div>购物车 <span>({{ proList.length }})</span></div>
        </div>
        <div class="cart_manager" @click="managerDel">{{ isDel?'退出管理':'管理' }}</div>
      </div>
      <van-checkbox-group ref="cartCheck" v-model="checkboxgroup" class="checkboxGroup">
        <MyscrollList ref="myList01" :loading="listLoading" :list="proList" :line="1" :line-type="1"
                      empty-msg="购物车里空空如也"
                      empty-image="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/cart_empty.png"
                      @myload="proload"
        >
          <template #default="slotProps">
            <div class="company_pro_list">
              <div class="flex-r-s-c">
                <van-checkbox v-model="slotProps.item.checked" :name="slotProps.item.productId" checked-color="#0767AB"
                              @click="itemChange($event,slotProps.item)"
                />
                <van-swipe-cell>
                  <proCard02 :info="slotProps.item" @changeNum="changeNum" />
                  <van-divider />
                  <template #right>
                    <van-button color="#D1531C" square text="删除" type="danger" class="delete-button" style="height:100%"
                                @click="delPro(slotProps)"
                    />
                  </template>
                </van-swipe-cell>
              </div>
            </div>
          </template>
        </MyscrollList>
      </van-checkbox-group>
    </div>
    <!-- 空状态 -->
    <!-- <van-empty v-if="proList.length === 0" class="custom-image"
               image="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/cart_empty.png"
               description="购物车里空空如也"
    /> -->
    <!-- 提交栏 -->
    <div v-if="proList.length>0" class="cart_sub">
      <van-submit-bar v-if="isDel">
        <div style="width:7rem;">
          <van-checkbox v-model="checkedAll" checked-color="#0767AB" @click="checkAll">全选</van-checkbox>
        </div>
        <template #button>
          <van-button round type="info" color="#D1531C" style="width: 2.93rem;" @click="delCart"> 删除 </van-button>
        </template>
      </van-submit-bar>
      <van-submit-bar v-else :price="cartProInfo.totalPrice">
        <van-checkbox v-model="checkedAll" checked-color="#0767AB" style="margin-top:0.15rem"
                      @click="checkAll"
        >全选</van-checkbox>
        <template #button>
          <van-button round type="info" color="#0767AB" @click="onSubmit">
            去结算{{ ' ( '+ result +' ) ' }}
          </van-button>
        </template>
      </van-submit-bar>
    </div>
    <!-- Tabber -->
    <Tabber ref="tabber" :index="3" />
  </div>
</template>

<script>
import './index.scss'
import Tabber from '@/components/tabber'
import MyscrollList from '@/components/MyscrollList'
import proCard02 from '@/components/pro_card_02'
import {
  shoppingCart_listUnion, shoppingCart_delete, shoppingCart_check, apiWholesaleCart_calcProductTotalPrice,
  apiWholesaleCart_updateCartProductCheckedAll, removeProductList
} from '@/api/cart'
export default {
  name: 'Cart',
  components: { proCard02, Tabber, MyscrollList },
  data() {
    return {
      reload: true,
      checkboxgroup: [],
      cartProInfo: { cartCompanies: [], totalPrice: 0 },
      result: 0,
      checkedAll: false,
      isDel: false,
      // 商品列表
      proSearch: { page: 1, limit: 10 },
      proList: [],
      listLoading: false
    }
  },
  created() {
    this.loadPro()
    this.$utils.cartNum(this.$store)
  },
  methods: {
    backPath() { window.history.back() },
    // 加载商品
    loadPro(index) {
      shoppingCart_listUnion(this.proSearch).then(res => {
        // this.$refs.myList01.load_loading(false)
        for (const i in res.data.list) {
          if (res.data.list[i].checked === 1) {
            this.checkboxgroup.push(res.data.list[i].productId)
          }
        }
        this.result = this.checkboxgroup.length
        this.$nextTick(() => {
          this.proList = this.proList.concat(res.data.list)
        })
        console.log('this.proList', this.proList)
        if (parseInt(res.data.total) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
        this.getPriceAll()
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.proSearch.page = this.proSearch.page + 1
        this.loadPro()
        // 加载状态结束
      }, 50)()
    },
    // 单个商品选择
    itemChange(val, item) {
      console.log('item.checked----------0', item.checked)
      item.checked = item.checked === 1 ? 0 : 1
      const parms = { checked: item.checked, productId: item.productId }
      shoppingCart_check(parms).then(res => {
        this.getPriceAll()
      })
      console.log('item.checked---------1', item.checked)
      // 计算个数
      this.result = item.checked === 1 ? this.result + 1 : this.result - 1
      if (this.result === this.proList.length) { this.checkedAll = true } else { this.checkedAll = false }
    },
    // 购物车全选
    checkAll() {
      this.$refs.cartCheck.toggleAll(this.checkedAll)
      this.result = this.checkedAll ? this.proList.length : 0
      for (const i in this.proList) { this.proList[i].checked = this.checkedAll ? 1 : 0 }
      apiWholesaleCart_updateCartProductCheckedAll({ checked: this.checkedAll ? 1 : 0 }).then(res => {
        this.getPriceAll()
      })
    },
    // 修改数量
    changeNum(num) {
      this.getPriceAll()
      // this.cartProInfo.totalPrice = parseInt(num.replace('.', ''))
    },
    // 删除商品
    delPro(slotProps) {
      this.reload = false
      shoppingCart_delete(slotProps.item.productId).then(res => {
        this.proList.splice(slotProps.index, 1)
        this.$utils.cartNum(this.$store)
        this.$forceUpdate()
        this.$nextTick(() => {
          this.reload = true
        })
      })
    },
    // 计算价格
    getPriceAll() {
      const parms = {
        page: 1,
        limit: 10,
        originType: this.checkedAll ? 3 : 1
      }
      apiWholesaleCart_calcProductTotalPrice(parms).then(res => {
        this.cartProInfo.totalPrice = parseInt(res.data.totalPrice.replace('.', ''))
      })
    },
    // 管理删除
    managerDel() {
      this.isDel = !this.isDel
    },
    delCart() {
      var productIdList = []
      if (this.checkedAll) {
        for (const i in this.proList) { productIdList.push(this.proList[i].productId) }
      } else {
        for (const i in this.proList) {
          if (this.proList[i].checked) {
            productIdList.push(this.proList[i].productId)
          }
        }
      }
      this.reload = false
      removeProductList({ productIdList: productIdList }).then(res => {
        this.proList = []
        this.proSearch.page = 1
        this.$toast({ message: '删除成功', duration: 1 * 1000 })
        this.$utils.cartNum(this.$store)
        this.loadPro()
        this.$forceUpdate()
        this.$nextTick(() => {
          this.reload = true
        })
      })
    },
    onSubmit() {
      // 组装数据 --》
      var items = ''
      var type = ''
      if (this.checkedAll) {
        type = 3
        items = this.proSearch.page + '-10'
      } else { type = 1 }
      if (this.result === 0) {
        this.$toast({ message: '暂无商品被选中, 无法提交', duration: 3 * 1000 })
      } else {
        this.$router.push(`/order/subOrder?type=${type}&item=${items}`)
      }
    }

  }
}
</script>
<style>
.custom-image {
  background: #fff;
  padding-top: 40%;
}
.custom-image .van-empty__image {
  width: 5.14rem;
  height: 3.43rem;
}
</style>
